export const SET_FILTERS = 'SET_FILTERS';
export const TOGGLE_FILTER_VALUE = 'TOGGLE_FILTER_VALUE';
export const RESET_FILTERS = 'RESET_FILTERS';
export const SET_FILTER_OPTIONS_LOADING = 'SET_FILTER_OPTIONS_LOADING';
export const SET_FILTER_OPTIONS_DATA = 'SET_FILTER_OPTIONS_DATA';
export const SET_FILTER_OPTIONS_ERROR = 'SET_FILTER_OPTIONS_ERROR';
export const SET_ACTIVE_MEASURE = 'SET_ACTIVE_MEASURE';
export const SET_KANBAN_SORT = 'SET_KANBAN_SORT';
export const RESET_ALL = 'RESET_ALL';
export const SET_VIEW = 'SET_VIEW';
export const SET_DISTRIBUTION_SORT = 'SET_DISTRIBUTION_SORT';
export const SET_SORT_METRIC = 'SET_SORT_METRIC';
export const SET_SIDE = 'SET_SIDE';
export const SET_COMPARE = 'SET_COMPARE';
export const SET_COMBINE = 'SET_COMBINE';
